import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { validarCPF } from 'src/app/core/utils/utilities';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-visualizacao-motorista',
  templateUrl: './visualizacao-motorista.component.html',
  styleUrl: './visualizacao-motorista.component.scss'
})
export class VisualizacaoMotoristaComponent {
  form: FormGroup = this._inicializarFormulario();
  title: string = 'Visualização de Motorista Externo';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public swalAlert: SwalAlertService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      PK_MTRT: ['', [Validators.required]],
      NM_MTRT: ['', [Validators.required]],
      TX_CPF_MTRT: [null, [validarCPF]],
      TX_CNH_MTRT: [null, [validarCPF]],
      TX_MAIL_MTRT: ['', [Validators.required]],
      TX_ENDE_CEP_MTRT: [null],
      TX_ENDE_ESTD_MTRT: [null],
      TX_ENDE_CDDE_MTRT: [null],
      TX_ENDE_RUA_MTRT: [null]
    });
    return form;
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params && Object.keys(params).length) {
        this.form.controls['PK_MTRT'].setValue(params['codigo'] ?? '---');
        this.form.controls['NM_MTRT'].setValue(params['nome'] ?? '---');
        this.form.controls['TX_CPF_MTRT'].setValue(params['cpf'] ?? '---');
        this.form.controls['TX_CNH_MTRT'].setValue(params['cnh'] ?? '---');
        this.form.controls['TX_MAIL_MTRT'].setValue(params['email'] ?? '---');
        this.form.controls['TX_ENDE_CEP_MTRT'].setValue(
          params['TX_ENDE_CEP_EXTR'] ?? '---'
        );
        this.form.controls['TX_ENDE_ESTD_MTRT'].setValue(
          params['TX_ENDE_ESTD_EXTR'] ?? '---'
        );
        this.form.controls['TX_ENDE_CDDE_MTRT'].setValue(
          params['TX_ENDE_CDDE_EXTR'] ?? '---'
        );
        this.form.controls['TX_ENDE_RUA_MTRT'].setValue(
          params['TX_ENDE_RUA_EXTR'] ?? '---'
        );
      }
    });
  }
}
